import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logoutAction } from "../../redux/slices/auth.slices";
import emailjs from "@emailjs/browser";

import { TopCoursesAria } from "../../components";
import TechvantoChat from "../../components/TechvantoChat"; // Import your Chatbot

import './home.css';

// ── DATA ──────────────────────────────────────────────────────────────────────

const HERO_CARDS = [
  { emoji: "👩‍💻", name: "Ankita Singh", role: "Full Stack Dev @ Razorpay", before: "BPO Executive — 2.8 LPA", after: "Full Stack Dev @ Razorpay — 16 LPA 🎉", hike: "471%", duration: "6 Months", placed: "3 Months" },
  { emoji: "👨‍💻", name: "Rohan Mehta", role: "Data Analyst @ Swiggy", before: "Operations Associate — 3.5 LPA", after: "Data Analyst @ Swiggy — 14 LPA 🎉", hike: "300%", duration: "8 Months", placed: "4 Months" },
  { emoji: "🧑‍💻", name: "Priya Krishnan", role: "Cloud Engineer @ PhonePe", before: "IT Helpdesk — 4.2 LPA", after: "Cloud Engineer @ PhonePe — 18 LPA 🎉", hike: "329%", duration: "6 Months", placed: "2 Months" },
  { emoji: "👩‍🔬", name: "Arjun Desai", role: "ML Engineer @ Meesho", before: "Mechanical Fresher — 0 LPA", after: "ML Engineer @ Meesho — 12 LPA 🎉", hike: "First Job", duration: "8 Months", placed: "5 Months" },
];

const COURSES = [
  { id: 1, icon: "💻", title: "Full-Stack Web Development", tech: "React • Node.js • MongoDB", price: "₹49,999", original: "₹79,999", rating: 4.9, reviews: 2840, duration: "16 weeks", students: "4,200+", level: "Beginner to Pro", image: "https://images.unsplash.com/photo-1593720213428-28a5b9e94613?w=600&h=320&fit=crop", tags: ["React", "Node.js", "MongoDB", "AWS"], accent: "#C0392B", badge: "Best Seller" },
  { id: 2, icon: "🤖", title: "Machine Learning & AI", tech: "Python • TensorFlow • MLOps", price: "₹54,999", original: "₹89,999", rating: 4.9, reviews: 2410, duration: "12 weeks", students: "2,400+", level: "Intermediate", image: "https://images.unsplash.com/photo-1677442136019-21780ecad979?w=600&h=320&fit=crop", tags: ["Python", "TensorFlow", "PyTorch", "MLOps"], accent: "#8B0000", badge: "Trending" },
  { id: 3, icon: "📊", title: "Data Science Mastery", tech: "Python • SQL • Tableau", price: "₹44,999", original: "₹74,999", rating: 4.8, reviews: 3120, duration: "12 weeks", students: "3,100+", level: "Beginner to Pro", image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=320&fit=crop", tags: ["Python", "SQL", "Tableau", "Power BI"], accent: "#C0392B", badge: "New" },
  { id: 4, icon: "☁️", title: "Cloud & DevOps Engineering", tech: "AWS • Docker • Kubernetes", price: "₹59,999", original: "₹94,999", rating: 4.8, reviews: 1650, duration: "14 weeks", students: "1,800+", level: "Intermediate", image: "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=600&h=320&fit=crop", tags: ["AWS", "Docker", "Kubernetes", "CI/CD"], accent: "#922B21", badge: "Hot" },
  { id: 5, icon: "🔐", title: "Cybersecurity & Ethical Hacking", tech: "Kali Linux • Penetration Testing", price: "₹52,999", original: "₹84,999", rating: 4.7, reviews: 1280, duration: "12 weeks", students: "1,400+", level: "Intermediate", image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=320&fit=crop", tags: ["Kali Linux", "Pen Testing", "OWASP", "CEH"], accent: "#8B0000", badge: null },
  { id: 6, icon: "📱", title: "Mobile App Development", tech: "React Native • Flutter • Swift", price: "₹47,999", original: "₹77,999", rating: 4.8, reviews: 1940, duration: "14 weeks", students: "2,100+", level: "Beginner to Pro", image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&h=320&fit=crop", tags: ["React Native", "Flutter", "Swift", "Kotlin"], accent: "#C0392B", badge: null },
  { id: 7, icon: "🎨", title: "UI/UX Design & Product", tech: "Figma • Design Systems • Research", price: "₹39,999", original: "₹64,999", rating: 4.9, reviews: 2200, duration: "10 weeks", students: "2,600+", level: "Beginner to Pro", image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=600&h=320&fit=crop", tags: ["Figma", "Prototyping", "UX Research", "Design Systems"], accent: "#922B21", badge: "Popular" },
  { id: 8, icon: "🧠", title: "Deep Learning & GenAI", tech: "PyTorch • Transformers • LLMs", price: "₹62,999", original: "₹98,999", rating: 4.9, reviews: 1540, duration: "14 weeks", students: "1,650+", level: "Advanced", image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=600&h=320&fit=crop", tags: ["PyTorch", "Transformers", "LangChain", "RAG"], accent: "#8B0000", badge: "Hot" },
  { id: 9, icon: "📱", title: "Android App Development", tech: "Kotlin • Jetpack • Firebase", price: "₹45,999", original: "₹75,999", rating: 4.8, reviews: 1680, duration: "12 weeks", students: "1,900+", level: "Beginner to Pro", image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=600&h=320&fit=crop", tags: ["Kotlin", "Jetpack", "Firebase", "Room"], accent: "#C0392B", badge: "New" },
  { id: 10, icon: "🍎", title: "iOS App Development", tech: "Swift • SwiftUI • Core Data", price: "₹48,999", original: "₹78,999", rating: 4.9, reviews: 1540, duration: "13 weeks", students: "1,700+", level: "Beginner to Pro", image: "https://images.unsplash.com/photo-1520333881886-03a580f73406?w=600&h=320&fit=crop", tags: ["Swift", "SwiftUI", "Core Data", "Combine"], accent: "#922B21", badge: "Popular" },
  { id: 11, icon: "🔧", title: "IoT & Embedded Systems", tech: "Arduino • Raspberry Pi • C/C++", price: "₹46,999", original: "₹76,999", rating: 4.8, reviews: 980, duration: "12 weeks", students: "1,200+", level: "Intermediate", image: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600&h=320&fit=crop", tags: ["Arduino", "Raspberry Pi", "C/C++", "MQTT"], accent: "#8B0000", badge: "Hot" },
  { id: 12, icon: "⚡", title: "VLSI & Hardware Design", tech: "Verilog • VHDL • Cadence", price: "₹55,999", original: "₹85,999", rating: 4.7, reviews: 720, duration: "14 weeks", students: "850+", level: "Advanced", image: "https://images.unsplash.com/photo-1555255707-c07966885b00?w=600&h=320&fit=crop", tags: ["Verilog", "VHDL", "Cadence", "Simulation"], accent: "#C0392B", badge: null },
];

const STATS = [
  { val: "15,000+", label: "Students Trained", icon: "👨‍🎓" },
  { val: "92%", label: "Placement Rate", icon: "🎯" },
  { val: "₹28 LPA", label: "Avg Salary Package", icon: "💰" },
  { val: "150+", label: "Hiring Partners", icon: "🤝" },
];

const PROGRAMS = [
  { badge: "MOST POPULAR", tag: "Full Stack Development", title: "Full Stack Web Development", subtitle: "For Beginners & Working Professionals", duration: "6 Months", mode: "Online Live", icon: "⚡", highlights: ["Master HTML, CSS, React, Node.js & MongoDB", "Build 10+ industry-grade projects", "1:1 mentorship & placement support"] },
  { badge: "HIGH DEMAND", tag: "Data Science & AI", title: "Data Science & Machine Learning", subtitle: "For Graduates & IT Professionals", duration: "8 Months", mode: "Online Live", icon: "🧠", highlights: ["Python, Pandas, ML, Deep Learning & LLMs", "Real-world datasets & capstone project", "Industry-recognized certification"] },
  { badge: "NEW LAUNCH", tag: "Cloud & DevOps", title: "Cloud Computing & DevOps", subtitle: "For Software Engineers", duration: "5 Months", mode: "Online Live", icon: "☁️", highlights: ["AWS, Docker, Kubernetes & CI/CD", "Hands-on labs with real cloud infra", "Prepare for AWS/GCP certifications"] },
];

const MENTORS = [
  { name: "Arjun Sharma", role: "SDE III @ Google", exp: "9 yrs", img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&h=120&fit=crop" },
  { name: "Priya Kapoor", role: "Data Scientist @ Microsoft", exp: "7 yrs", img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop" },
  { name: "Rahul Mehta", role: "Tech Lead @ Amazon", exp: "11 yrs", img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&h=120&fit=crop" },
  { name: "Sneha Joshi", role: "ML Engineer @ Meta", exp: "6 yrs", img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&h=120&fit=crop" },
  { name: "Vikram Singh", role: "DevOps Lead @ Flipkart", exp: "8 yrs", img: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&h=120&fit=crop" },
  { name: "Anika Patel", role: "Full Stack @ Razorpay", exp: "5 yrs", img: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&h=120&fit=crop" },
];

const ALUMNI = [
  { name: "Arun Kumar", role: "ML Engineer", company: "Google", pkg: "₹48 LPA", img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&h=120&fit=crop", quote: "The hands-on projects and mentorship were transformational. Landed at Google within 3 months!", course: "Machine Learning & AI" },
  { name: "Shreya Gupta", role: "Data Scientist", company: "Amazon", pkg: "₹38 LPA", img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop", quote: "From zero ML experience to confidently building production systems. The curriculum is world-class.", course: "Data Science Mastery" },
  { name: "Rahul Nair", role: "Senior SDE", company: "Microsoft", pkg: "₹45 LPA", img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&h=120&fit=crop", quote: "Best ROI of my life. The full-stack bootcamp prepared me for interviews better than 2 years of self-study.", course: "Full-Stack Web Dev" },
  { name: "Neha Singh", role: "UI/UX Lead", company: "Meta", pkg: "₹42 LPA", img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&h=120&fit=crop", quote: "The design thinking framework and real-world projects helped me crack Meta's intense design rounds.", course: "UI/UX Design" },
  { name: "Vikram Joshi", role: "DevOps Engineer", company: "Apple", pkg: "₹52 LPA", img: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&h=120&fit=crop", quote: "Incredible community and mentorship. The Cloud & DevOps curriculum is among the best I've seen.", course: "Cloud & DevOps" },
  { name: "Priya Reddy", role: "Security Engineer", company: "JPMorgan", pkg: "₹36 LPA", img: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&h=120&fit=crop", quote: "Real-world lab environments made all the difference. Got placed with a 95% pay hike!", course: "Cybersecurity" },
];

const WHY_US = [
  { icon: "👨‍💼", title: "FAANG Mentors", desc: "Learn from Google, Amazon, Microsoft, Meta engineers with 15+ years of real industry experience." },
  { icon: "📈", title: "92% Placement Rate", desc: "Highest placement rate in the industry. Average ₹28 LPA CTC at top tech companies globally." },
  { icon: "🔧", title: "Project-Driven Learning", desc: "Build 6–8 end-to-end real-world projects deployed to production. Portfolio-ready work for interviews." },
  { icon: "🤝", title: "1-on-1 Mentorship", desc: "Weekly dedicated mentorship sessions with FAANG engineers. Personalized career coaching." },
  { icon: "💼", title: "Job Guarantee", desc: "50% refund if not placed in 6 months. 150+ hiring partners actively recruiting our students." },
  { icon: "🌍", title: "Global Community", desc: "15,000+ alumni across 50+ countries. Lifelong networking, events, and career support." },
];

const PROCESS = [
  { n: "01", icon: "🎯", title: "Career Assessment", desc: "1-on-1 session to understand your goals and craft a personalized learning path." },
  { n: "02", icon: "📚", title: "Live Interactive Classes", desc: "2-hour live sessions with industry experts. Real-time Q&A, small batches of 25." },
  { n: "03", icon: "🛠️", title: "Hands-On Projects", desc: "Build 6–8 real-world projects with mentorship. Kaggle competitions, end-to-end systems." },
  { n: "04", icon: "📊", title: "Mock Interviews", desc: "Weekly mock interviews with ex-FAANG engineers. Technical, system design, behavioral rounds." },
  { n: "05", icon: "🤝", title: "1-on-1 Mentorship", desc: "Weekly 1-hour sessions with your assigned mentor. Career guidance and doubt clearing." },
  { n: "06", icon: "🚀", title: "Placement Drive", desc: "Interview coaching, CV optimization, direct referrals to 150+ hiring partners." },
];

const FAQS = [
  { q: "What's the difference between bootcamps and online courses?", a: "Our Full-Time Bootcamp is a 12-week intensive program with 40+ hours/week of live classes, hands-on projects, and daily 1-on-1 mentorship. Online courses are part-time (8-10 hours/week) with recorded lectures, live Q&A, and async mentorship." },
  { q: "Do I need prior programming experience?", a: "For most tech courses, basic programming comfort helps. We offer a 2-week Foundations module before the main program for beginners. Our curriculum progressively builds from fundamentals to advanced concepts." },
  { q: "What's your placement rate and average salary?", a: "92% of graduates are placed within 4 months, with an average CTC of ₹28 LPA. We've placed students at 150+ companies including Google, Amazon, Microsoft, Meta, Apple, JPMorgan, Flipkart, Zomato, and more." },
  { q: "Is there a refund if I don't get a job?", a: "Yes. Our Job Guarantee Refund Policy — if you complete the program and don't get placed within 6 months, we refund 50% of fees. Most students are placed within 3-4 months." },
  { q: "Can I balance the course with my full-time job?", a: "Absolutely. Our Part-Time and Online courses are designed for working professionals. 8-10 hours per week is sufficient. Many students transition to better roles while still learning." },
];

const COMPANIES = [
  { name: "Microsoft", logo: "/logos/microsoft.svg", color: "#00A4EF" },
  { name: "Amazon", logo: "/logos/amazon.svg", color: "#FF9900" },
  { name: "Intel", logo: "/logos/intel.svg", color: "#00A4EF" },
  { name: "Apple", logo: "/logos/apple.svg", color: "#555555" },
  { name: "Meta", logo: "/logos/meta.svg", color: "#0064E0" },
  { name: "Flipkart", logo: "/logos/flipkart.svg", color: "#1D1D7A" },
  { name: "Zomato", logo: "/logos/zomato.svg", color: "#E84829" },
  { name: "PhonePe", logo: "/logos/phonepe.svg", color: "#5F2EF7" },
  { name: "Razorpay", logo: "/logos/razorpay.svg", color: "#0055FF" },
  { name: "Swiggy", logo: "/logos/swiggy.svg", color: "#F37335" },
];

const UNIVERSITIES = [
  { name: "IIT Bhubaneswar", logo: "/logos/iitbhub.png" },
  { name: "IIT Kanpur", logo: "/logos/iitk.png" },
  { name: "IIT Hyderabad", logo: "/logos/iith.png" },
  { name: "IIM Noida", logo: "/logos/iimtn.png" },
  { name: "LPU", logo: "/logos/lpu.png" },
  { name: "NIT Jalandhar", logo: "/logos/nitj.png" },
];

const TECH_STACK = [
  { category: "Frontend", items: [
    { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" },
    { name: "Next.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg" },
    { name: "Vue.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg" },
    { name: "TypeScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg" },
    { name: "Tailwind", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg" },
    { name: "Flutter", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg" },
  ]},
  { category: "Backend", items: [
    { name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg" },
    { name: "Python", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg" },
    { name: "Java", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-original.svg" },
    { name: "Go", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/go/go-original.svg" },
    { name: "Django", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/django/django-plain.svg" },
    { name: "GraphQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/graphql/graphql-plain.svg" },
  ]},
  { category: "AI / ML", items: [
    { name: "TensorFlow", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tensorflow/tensorflow-original.svg" },
    { name: "PyTorch", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pytorch/pytorch-original.svg" },
    { name: "Scikit-Learn", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/scikitlearn/scikitlearn-original.svg" },
    { name: "Jupyter", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jupyter/jupyter-original.svg" },
    { name: "Pandas", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pandas/pandas-original.svg" },
    { name: "OpenCV", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/opencv/opencv-original.svg" },
  ]},
  { category: "Cloud & DevOps", items: [
    { name: "AWS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg" },
    { name: "GCP", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/googlecloud/googlecloud-original.svg" },
    { name: "Docker", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg" },
    { name: "Kubernetes", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kubernetes/kubernetes-plain.svg" },
    { name: "Terraform", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/terraform/terraform-original.svg" },
    { name: "GitHub Actions", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/githubactions/githubactions-original.svg" },
  ]},
  { category: "Android", items: [
    { name: "Kotlin", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kotlin/kotlin-original.svg" },
    { name: "Java", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-original.svg" },
    { name: "Android Studio", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/androidstudio/androidstudio-original.svg" },
    { name: "Jetpack", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jetpackcompose/jetpackcompose-original.svg" },
    { name: "Firebase", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg" },
    { name: "Gradle", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/gradle/gradle-original.svg" },
  ]},
  { category: "iOS", items: [
    { name: "Swift", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/swift/swift-original.svg" },
    { name: "Xcode", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/xcode/xcode-original.svg" },
    { name: "Objective-C", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/objectivec/objectivec-plain.svg" },
    { name: "SwiftUI", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/swiftui/swiftui-original.svg" },
    { name: "Core Data", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/coredata/coredata-original.svg" },
    { name: "CocoaPods", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cocoapods/cocoapods-original.svg" },
  ]},
  { category: "IoT & Embedded", items: [
    { name: "Arduino", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/arduino/arduino-original.svg" },
    { name: "C++", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cplusplus/cplusplus-original.svg" },
    { name: "Raspberry Pi", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/raspberrypi/raspberrypi-original.svg" },
    { name: "C", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/c/c-original.svg" },
    { name: "MQTT", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dot-net/dot-net-original.svg" },
    { name: "TI MSP430", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/embeddedsystems/embeddedsystems-original.svg" },
  ]},
];

// ── THEME ─────────────────────────────────────────────────────────────────────
const R = {
  crimson:   "#C0392B",
  ruby:      "#8B0000",
  scarlet:   "#E74C3C",
  rose:      "#FDEDEC",
  roseMid:   "#FADBD8",
  gold:      "#D4A017",
  goldLight: "#F9E79F",
  cream:     "#FDF6F0",
  parchment: "#FAF0E6",
  dark:      "#1A0A0A",
  darkMid:   "#2C0F0F",
  darkCard:  "#3D1515",
  white:     "#FFFFFF",
  offWhite:  "#FFF8F8",
};

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700&display=swap');

*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
html{scroll-behavior:smooth;}
body{font-family:'Sora',sans-serif;background:${R.cream};color:#2C1010;overflow-x:hidden;}

::-webkit-scrollbar{width:5px;}
::-webkit-scrollbar-track{background:${R.rose};}
::-webkit-scrollbar-thumb{background:linear-gradient(${R.crimson},${R.ruby});border-radius:3px;}

/* === KEYFRAMES === */
@keyframes fadeUp{from{opacity:0;transform:translateY(28px);}to{opacity:1;transform:none;}}
@keyframes fadeIn{from{opacity:0;}to{opacity:1;}}
@keyframes float{0%,100%{transform:translateY(0) rotate(0deg);}50%{transform:translateY(-14px) rotate(1deg);}}
@keyframes floatR{0%,100%{transform:translateY(0) rotate(0deg);}50%{transform:translateY(-10px) rotate(-1deg);}}
@keyframes pulse{0%,100%{opacity:1;transform:scale(1);}50%{opacity:.5;transform:scale(0.85);}}
@keyframes ticker{0%{transform:translateX(0);}100%{transform:translateX(-50%);}}
@keyframes shimmer{0%{background-position:-200% 0;}100%{background-position:200% 0;}}
@keyframes ripple{0%{transform:scale(0);opacity:.6;}100%{transform:scale(3.5);opacity:0;}}
@keyframes borderGlow{0%,100%{box-shadow:0 0 0 0 rgba(192,57,43,.0),inset 0 1px 0 rgba(255,255,255,.2);}50%{box-shadow:0 0 28px 4px rgba(192,57,43,.25),inset 0 1px 0 rgba(255,255,255,.2);}}
@keyframes stampIn{0%{transform:scale(1.4) rotate(-8deg);opacity:0;}60%{transform:scale(0.95) rotate(2deg);opacity:1;}100%{transform:scale(1) rotate(0deg);opacity:1;}}
@keyframes slideLeft{from{transform:translateX(30px);opacity:0;}to{transform:translateX(0);opacity:1;}}
@keyframes heartbeat{0%,100%{transform:scale(1);}14%{transform:scale(1.06);}28%{transform:scale(1);}42%{transform:scale(1.04);}70%{transform:scale(1);}}
@keyframes rotateSlow{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}
@keyframes waveText{0%,100%{transform:translateY(0);}50%{transform:translateY(-4px);}}
@keyframes colorize{0%{filter:grayscale(100%);}100%{filter:grayscale(0%);}}

.ff-display{font-family:'Sora',sans-serif;font-weight:700;}
.ff-body{font-family:'Sora',sans-serif;font-weight:400;}

/* Sections alternating light / dark */
.section-light{background:${R.cream};}
.section-parchment{background:${R.parchment};}
.section-dark{background:${R.dark}; color:#F5E6E6;}
.section-dark-mid{background:${R.darkMid}; color:#F5E6E6;}
.section-white{background:#fff;}

/* Glass cards — light context */
.card-light{
  background:rgba(255,255,255,.88);
  border:1.5px solid rgba(192,57,43,.15);
  backdrop-filter:blur(12px);
  box-shadow:0 8px 32px rgba(192,57,43,.08), 0 1px 0 rgba(255,255,255,.9) inset;
}
/* Glass cards — dark context */
.card-dark{
  background:rgba(61,21,21,.55);
  border:1px solid rgba(192,57,43,.25);
  backdrop-filter:blur(14px);
  box-shadow:0 8px 32px rgba(0,0,0,.35);
}

.btn-royal{
  position:relative;overflow:hidden;
  background:linear-gradient(135deg,${R.crimson} 0%,${R.ruby} 60%,#5C0000 100%);
  border:none;cursor:pointer;
  color:#fff;font-family:'Sora',sans-serif;font-weight:600;
  transition:transform .25s cubic-bezier(.4,0,.2,1),box-shadow .25s;
  box-shadow:0 4px 24px rgba(192,57,43,.45), 0 1px 0 rgba(255,255,255,.12) inset;
}
.btn-royal::before{
  content:'';position:absolute;inset:0;
  background:linear-gradient(135deg,rgba(255,255,255,.18) 0%,transparent 60%);
  pointer-events:none;
}
.btn-royal::after{
  content:'';position:absolute;
  width:100%;height:100%;
  background:radial-gradient(circle,rgba(255,255,255,.35) 0%,transparent 60%);
  transform:scale(0);border-radius:50%;
  top:0;left:0;transition:transform .5s,opacity .5s;opacity:0;
}
.btn-royal:hover{transform:translateY(-3px) scale(1.02);box-shadow:0 10px 40px rgba(192,57,43,.6), 0 1px 0 rgba(255,255,255,.15) inset;}
.btn-royal:active::after{transform:scale(3.5);opacity:0;transition:0s;}

.btn-outline-royal{
  position:relative;overflow:hidden;
  background:transparent;
  border:2px solid ${R.crimson};
  cursor:pointer;color:${R.crimson};
  font-family:'Sora',sans-serif;font-weight:600;
  transition:all .25s cubic-bezier(.4,0,.2,1);
}
.btn-outline-royal::before{
  content:'';position:absolute;inset:0;
  background:${R.crimson};
  transform:scaleX(0);transform-origin:left;
  transition:transform .3s cubic-bezier(.4,0,.2,1);
}
.btn-outline-royal:hover{color:#fff;}
.btn-outline-royal:hover::before{transform:scaleX(1);}
.btn-outline-royal:hover span{color:#fff;transition:color .3s;}
.btn-outline-royal span{position:relative;z-index:1;}

.btn-gold{
  background:linear-gradient(135deg,${R.gold} 0%,#B8860B 100%);
  border:none;cursor:pointer;color:#fff;
  font-family:'Sora',sans-serif;font-weight:600;
  box-shadow:0 4px 20px rgba(212,160,23,.4);
  transition:all .25s;
}
.btn-gold:hover{transform:translateY(-2px);box-shadow:0 8px 32px rgba(212,160,23,.6);}

/* Course card */
.course-card{
  background:#fff;
  border:1.5px solid rgba(192,57,43,.1);
  border-radius:20px;overflow:hidden;
  transition:transform .35s cubic-bezier(.4,0,.2,1), box-shadow .35s, border-color .35s;
  cursor:pointer;position:relative;
}
.course-card::before{
  content:'';position:absolute;inset:0;
  background:linear-gradient(135deg,rgba(192,57,43,.04) 0%,transparent 60%);
  opacity:0;transition:opacity .35s;pointer-events:none;z-index:0;
}
.course-card:hover{
  transform:translateY(-10px) scale(1.015);
  box-shadow:0 32px 80px rgba(192,57,43,.18), 0 4px 16px rgba(0,0,0,.08);
  border-color:rgba(192,57,43,.4);
}
.course-card:hover::before{opacity:1;}

/* Why card */
.why-card{
  border-radius:20px;padding:28px 24px;
  border:1.5px solid rgba(192,57,43,.1);
  background:#fff;
  transition:all .3s cubic-bezier(.4,0,.2,1);
  position:relative;overflow:hidden;
}
.why-card::after{
  content:'';position:absolute;
  bottom:0;left:0;right:0;height:3px;
  background:linear-gradient(90deg,${R.crimson},${R.gold},${R.crimson});
  transform:scaleX(0);transition:transform .3s;transform-origin:left;
}
.why-card:hover{
  transform:translateY(-8px);
  box-shadow:0 24px 64px rgba(192,57,43,.14);
  border-color:rgba(192,57,43,.3);
}
.why-card:hover::after{transform:scaleX(1);}

/* Mentor card */
.mentor-card{
  border-radius:20px;padding:22px 18px;
  background:#fff;border:1.5px solid rgba(192,57,43,.1);
  transition:all .3s cubic-bezier(.4,0,.2,1);
  position:relative;overflow:hidden;
}
.mentor-card:hover{
  transform:translateY(-6px) scale(1.02);
  box-shadow:0 20px 56px rgba(192,57,43,.15);
  border-color:rgba(192,57,43,.35);
}

/* Process card on light bg */
.process-card-light{
  border-radius:20px;padding:30px 24px;
  background:#fff;
  border:1.5px solid rgba(192,57,43,.12);
  transition:all .3s cubic-bezier(.4,0,.2,1);
  position:relative;overflow:hidden;
}
.process-card-light::before{
  content:'';position:absolute;top:0;left:0;right:0;height:2px;
  background:linear-gradient(90deg,transparent,${R.crimson},transparent);
  transform:scaleX(0);transition:transform .3s;
}
.process-card-light:hover{
  background:rgba(192,57,43,.02);
  transform:translateY(-6px);
  box-shadow:0 20px 50px rgba(192,57,43,.1), 0 0 30px rgba(192,57,43,.08);
  border-color:rgba(192,57,43,.3);
}
.process-card-light:hover::before{transform:scaleX(1);}

/* Shimmer badge */
.shimmer-badge{
  background:linear-gradient(100deg, ${R.crimson} 40%, ${R.scarlet} 50%, ${R.crimson} 60%);
  background-size:200% 100%;
  animation:shimmer 2.5s infinite linear;
}

/* Company logo wrapper */
.company-logo-wrapper{
  transition:all .4s cubic-bezier(.4,0,.2,1);
  filter:grayscale(100%);
}
.company-logo-wrapper:hover{
  filter:grayscale(0%);
  transform:scale(1.08);
}

/* Ticker */
.ticker-wrap{overflow:hidden;}
.ticker-inner{display:inline-flex;animation:ticker 30s linear infinite;white-space:nowrap;}
.ticker-wrap:hover .ticker-inner{animation-play-state:paused;}

/* Section label */
.section-label-light{
  display:inline-block;font-size:11px;font-weight:600;
  letter-spacing:.18em;text-transform:uppercase;
  padding:5px 16px;border-radius:99px;margin-bottom:16px;
  background:rgba(192,57,43,.1);color:${R.crimson};
  border:1px solid rgba(192,57,43,.25);
}
.section-label-dark{
  display:inline-block;font-size:11px;font-weight:600;
  letter-spacing:.18em;text-transform:uppercase;
  padding:5px 16px;border-radius:99px;margin-bottom:16px;
  background:rgba(192,57,43,.2);color:#F1948A;
  border:1px solid rgba(192,57,43,.4);
}
.section-label-gold{
  display:inline-block;font-size:11px;font-weight:600;
  letter-spacing:.18em;text-transform:uppercase;
  padding:5px 16px;border-radius:99px;margin-bottom:16px;
  background:rgba(212,160,23,.15);color:${R.gold};
  border:1px solid rgba(212,160,23,.35);
}

.faq-item{
  border:1.5px solid rgba(192,57,43,.12);
  border-radius:16px;overflow:hidden;
  margin-bottom:10px;
  transition:border-color .22s, box-shadow .22s;
  background:#fff;
}
.faq-item:hover{border-color:rgba(192,57,43,.35);box-shadow:0 8px 24px rgba(192,57,43,.08);}
.faq-open{border-color:rgba(192,57,43,.5) !important;background:rgba(253,237,236,.5);}

/* Diagonal divider */
.divider-red{
  height:60px;background:${R.cream};
  clip-path:polygon(0 0,100% 100%,100% 100%,0 100%);
  position:relative;z-index:1;
}

/* Ornamental line */
.ornament{
  display:flex;align-items:center;gap:14px;
  color:${R.crimson};font-size:13px;font-weight:600;
  letter-spacing:.12em;text-transform:uppercase;
}
.ornament::before,.ornament::after{
  content:'';flex:1;height:1px;
  background:linear-gradient(90deg,transparent,rgba(192,57,43,.35),transparent);
}

/* Red seal */
.red-seal{
  display:inline-flex;align-items:center;justify-content:center;
  width:72px;height:72px;border-radius:50%;
  background:linear-gradient(135deg,${R.crimson},${R.ruby});
  color:#fff;font-size:28px;
  box-shadow:0 8px 28px rgba(192,57,43,.4);
  animation:heartbeat 2.8s infinite;
}

/* Gold strip */
.gold-strip{
  height:3px;
  background:linear-gradient(90deg,${R.crimson},${R.gold},${R.crimson});
  background-size:200% 100%;
  animation:shimmer 3s infinite linear;
}

@media(max-width:900px){
  .nav-links-desktop{display:none !important;}
  .mob-menu-btn{display:flex !important;}
  .hero-grid{grid-template-columns:1fr !important;}
  .stats-row{grid-template-columns:repeat(2,1fr) !important;}
  .programs-split{grid-template-columns:1fr !important;}
  .mentors-grid{grid-template-columns:repeat(2,1fr) !important;}
  .courses-grid{grid-template-columns:repeat(auto-fill,minmax(280px,1fr)) !important;}
  .why-grid{grid-template-columns:repeat(2,1fr) !important;}
  .process-grid{grid-template-columns:repeat(2,1fr) !important;}
  .alumni-grid{grid-template-columns:1fr !important;}
  .tech-grid{grid-template-columns:repeat(3,1fr) !important;}
  .story-split{grid-template-columns:1fr !important;}
  .footer-grid{grid-template-columns:1fr 1fr !important;}
  .cta-split{grid-template-columns:1fr !important;}
}
@media(max-width:600px){
  .stats-row{grid-template-columns:repeat(2,1fr) !important;}
  .why-grid{grid-template-columns:1fr !important;}
  .process-grid{grid-template-columns:1fr !important;}
  .tech-grid{grid-template-columns:repeat(2,1fr) !important;}
  .mentors-grid{grid-template-columns:1fr !important;}
  .footer-grid{grid-template-columns:1fr !important;}
}
`;

// ── COMPONENTS ────────────────────────────────────────────────────────────────

function Stars({ rating }) {
  return (
    <span style={{ display:"inline-flex",gap:2 }}>
      {[1,2,3,4,5].map(i=>(
        <span key={i} style={{color:i<=Math.round(rating)?R.gold:"#DDD",fontSize:12}}>★</span>
      ))}
    </span>
  );
}

// ── HERO ──────────────────────────────────────────────────────────────────────
function Hero() {
  const [cardIdx,setCardIdx]=useState(0);
  const [metric,setMetric]=useState(0);
  const [companyIdx, setCompanyIdx] = useState(0); 

  const metrics=["15,000+ Students Trained","92% Placement Rate","₹28 LPA Avg Salary","150+ Hiring Partners"];
  const companies = ["Microsoft.", "Google.", "Amazon.", "Meta.", "Apple.", "Flipkart."];

  useEffect(()=>{
    const t1=setInterval(()=>setCardIdx(c=>(c+1)%HERO_CARDS.length),5000);
    const t2=setInterval(()=>setMetric(m=>(m+1)%metrics.length),2800);
    const t3=setInterval(()=>setCompanyIdx(c=>(c+1)%companies.length), 2500); 
    return ()=>{clearInterval(t1);clearInterval(t2);clearInterval(t3);};
  },[]);

  const card=HERO_CARDS[cardIdx];

  return (
    <section className="section-light" style={{minHeight:"100vh",paddingTop:140,paddingBottom:80,position:"relative",overflow:"hidden",fontFamily:"'Sora',sans-serif"}}>
      <div style={{position:"absolute",top:"10%",right:"-5%",width:600,height:600,borderRadius:"50%",background:`radial-gradient(circle,rgba(192,57,43,.08) 0%,transparent 70%)`,pointerEvents:"none"}} />
      <div style={{position:"absolute",bottom:"5%",left:"-10%",width:400,height:400,borderRadius:"50%",background:`radial-gradient(circle,rgba(212,160,23,.06) 0%,transparent 70%)`,pointerEvents:"none"}} />
      <svg style={{position:"absolute",inset:0,width:"100%",height:"100%",pointerEvents:"none",opacity:.04}} xmlns="http://www.w3.org/2000/svg">
        <defs><pattern id="grid" width="48" height="48" patternUnits="userSpaceOnUse"><path d="M 48 0 L 0 0 0 48" fill="none" stroke={R.crimson} strokeWidth="1"/></pattern></defs>
        <rect width="100%" height="100%" fill="url(#grid)"/>
      </svg>

      <div style={{maxWidth:1300,margin:"0 auto",padding:"0 32px"}}>
        <div className="hero-grid" style={{display:"grid",gridTemplateColumns:"1.1fr .9fr",gap:64,alignItems:"center"}}>
          <div style={{animation:"fadeUp .7s ease forwards"}}>
            <div style={{display:"inline-flex",alignItems:"center",gap:12,background:`rgba(192,57,43,.08)`,border:`1.5px solid rgba(192,57,43,.2)`,borderRadius:99,padding:"8px 20px",marginBottom:28,fontFamily:"'Sora',sans-serif"}}>
              <span style={{width:8,height:8,borderRadius:"50%",background:R.crimson,display:"inline-block",animation:"pulse 1.8s infinite"}} />
              <span style={{fontSize:12.5,fontWeight:600,color:R.crimson,letterSpacing:".05em"}}>India's #1 Tech Career Platform</span>
            </div>

            <h1 className="ff-display" style={{fontSize:"clamp(28px, 4vw, 52px)",fontWeight:700,lineHeight:1.1,marginBottom:22,letterSpacing:"-.02em",color:R.dark,fontFamily:"'Sora',sans-serif"}}>
             
              <span style={{fontSize:"clamp(20px, 2.5vw, 38px)"}}>Our students placed at </span>
              <span key={companyIdx} style={{ display: "inline-block" }}>
                {companies[companyIdx].split("").map((char, index) => (
                  <span
                    key={index}
                    style={{
                      display: "inline-block",
                      opacity: 0, 
                      animation: `fadeUp 0.4s ease forwards ${index * 0.08}s`, 
                      background: `linear-gradient(135deg, ${R.crimson}, ${R.ruby}, ${R.scarlet})`,
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    {char === " " ? "\u00A0" : char}
                  </span>
                ))}
              </span>
            </h1>

            <p style={{fontSize:17,color:"#6B3030",lineHeight:1.85,maxWidth:540,marginBottom:28,fontWeight:400,fontFamily:"'Sora',sans-serif"}}>
              From Web Dev to AI, Cloud to Blockchain — learn from FAANG engineers with live classes, real projects, and a 92% placement guarantee.
            </p>

            <div style={{display:"inline-flex",alignItems:"center",gap:10,background:`rgba(212,160,23,.1)`,border:`1px solid rgba(212,160,23,.35)`,borderRadius:12,padding:"10px 18px",marginBottom:32,fontFamily:"'Sora',sans-serif"}}>
              <span style={{fontSize:16}}>✨</span>
              <span className="ff-display" style={{fontWeight:600,fontSize:14,color:R.gold,animation:"slideLeft .4s ease",fontFamily:"'Sora',sans-serif"}} key={metric}>{metrics[metric]}</span>
            </div>

            <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:44}}>
              <a href="/#/all-courses/college" className="btn-royal ff-display" style={{color:"#fff",padding:"15px 32px",borderRadius:12,fontSize:15,textDecoration:"none",display:"inline-block",fontFamily:"'Sora',sans-serif"}}>🎓 Explore Courses</a>
              
              <a 
                href="#contact" 
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }} 
                className="btn-outline-royal ff-display" 
                style={{padding:"15px 28px",borderRadius:12,fontSize:15,textDecoration:"none",display:"inline-block",background:"transparent",fontFamily:"'Sora',sans-serif"}}
              >
                <span>📞 Book Free Demo</span>
              </a>
            </div>

            <div style={{display:"flex",gap:32,flexWrap:"wrap",paddingTop:24,borderTop:`1px solid rgba(192,57,43,.12)`,fontFamily:"'Sora',sans-serif"}}>
              {[["15K+","Students"],["92%","Placement"],["₹28 LPA","Avg Salary"],["150+","Partners"]].map(([v,l])=>(
                <div key={l}>
                  <div className="ff-display" style={{fontWeight:700,fontSize:26,color:R.crimson,fontFamily:"'Sora',sans-serif"}}>{v}</div>
                  <div style={{fontSize:12,color:"#8B4444",fontWeight:500,marginTop:2,fontFamily:"'Sora',sans-serif"}}>{l}</div>
                </div>
              ))}
            </div>

            <div style={{display:"flex",gap:20,flexWrap:"wrap",marginTop:24,fontFamily:"'Sora',sans-serif"}}>
              {["🏆 ISO Certified","⭐ 4.9/5 Rating","🔒 100% Secure"].map(t=>(
                <span key={t} style={{fontSize:12,color:"#8B4444",fontWeight:500,fontFamily:"'Sora',sans-serif"}}>{t}</span>
              ))}
            </div>
          </div>

          <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
            <div style={{width:"100%",maxWidth:440,position:"relative"}}>
              <div key={cardIdx} style={{borderRadius:24,overflow:"hidden",background:"#fff",border:`2px solid rgba(192,57,43,.15)`,boxShadow:`0 40px 100px rgba(192,57,43,.15), 0 8px 32px rgba(0,0,0,.08)`,animation:"fadeUp .45s ease, float 5s ease-in-out 1s infinite",fontFamily:"'Sora',sans-serif"}}>
                <div style={{height:4,background:`linear-gradient(90deg,${R.ruby},${R.crimson},${R.scarlet},${R.gold})`}} />
                <div style={{padding:"28px 28px 24px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:24}}>
                    <div style={{width:54,height:54,borderRadius:"50%",background:`linear-gradient(135deg,${R.crimson},${R.ruby})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,flexShrink:0,boxShadow:`0 6px 20px rgba(192,57,43,.4)`}}>
                      {card.emoji}
                    </div>
                    <div>
                      <div className="ff-display" style={{fontWeight:700,fontSize:16,color:R.dark,fontFamily:"'Sora',sans-serif"}}>{card.name}</div>
                      <div style={{fontSize:13,color:R.crimson,fontWeight:600,fontFamily:"'Sora',sans-serif"}}>{card.role}</div>
                    </div>
                    <div style={{marginLeft:"auto",background:`rgba(192,57,43,.08)`,borderRadius:99,padding:"4px 12px",fontSize:11,fontWeight:600,color:R.crimson,border:`1px solid rgba(192,57,43,.2)`,fontFamily:"'Sora',sans-serif"}}>★ Placed</div>
                  </div>

                  <div style={{background:"rgba(255,235,235,.6)",borderRadius:12,padding:"13px 16px",marginBottom:12,borderLeft:`3px solid #E74C3C`,fontFamily:"'Sora',sans-serif"}}>
                    <div style={{fontSize:10.5,color:"#888",fontWeight:600,marginBottom:4,textTransform:"uppercase",letterSpacing:".08em",fontFamily:"'Sora',sans-serif"}}>Before Techvanto Academy</div>
                    <div style={{fontSize:14,fontWeight:500,color:"#4A2020",fontFamily:"'Sora',sans-serif"}}>{card.before}</div>
                  </div>

                  <div style={{background:`rgba(192,57,43,.07)`,borderRadius:12,padding:"13px 16px",marginBottom:22,borderLeft:`3px solid ${R.crimson}`,fontFamily:"'Sora',sans-serif"}}>
                    <div style={{fontSize:10.5,color:"#888",fontWeight:600,marginBottom:4,textTransform:"uppercase",letterSpacing:".08em",fontFamily:"'Sora',sans-serif"}}>After Techvanto Academy</div>
                    <div style={{fontSize:14,fontWeight:700,color:R.crimson,fontFamily:"'Sora',sans-serif"}}>{card.after}</div>
                  </div>

                  <div style={{display:"flex",justifyContent:"space-between",borderTop:`1px solid rgba(192,57,43,.1)`,paddingTop:18,gap:8,fontFamily:"'Sora',sans-serif"}}>
                    {[{v:card.hike,l:"Salary Hike",c:R.crimson},{v:card.duration,l:"Duration",c:"#8B4444"},{v:"Placed ✓",l:`In ${card.placed}`,c:"#27AE60"}].map(s=>(
                      <div key={s.l} style={{textAlign:"center",flex:1}}>
                        <div className="ff-display" style={{fontWeight:700,fontSize:18,color:s.c,fontFamily:"'Sora',sans-serif"}}>{s.v}</div>
                        <div style={{fontSize:11,color:"#888",marginTop:3,fontFamily:"'Sora',sans-serif"}}>{s.l}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {[-1,1].map(dir=>(
                <button key={dir} onClick={()=>setCardIdx(c=>(c+dir+HERO_CARDS.length)%HERO_CARDS.length)}
                  style={{position:"absolute",[dir===-1?"left":"right"]:-18,top:"50%",transform:"translateY(-50%)",width:38,height:38,borderRadius:"50%",border:`1.5px solid rgba(192,57,43,.2)`,background:"#fff",cursor:"pointer",fontSize:18,display:"flex",alignItems:"center",justifyContent:"center",color:R.crimson,boxShadow:"0 4px 12px rgba(192,57,43,.15)",transition:"all .2s",fontFamily:"'Sora',sans-serif"}}
                  onMouseEnter={e=>{e.currentTarget.style.background=R.crimson;e.currentTarget.style.color="#fff";}}
                  onMouseLeave={e=>{e.currentTarget.style.background="#fff";e.currentTarget.style.color=R.crimson;}}
                >{dir===-1?"‹":"›"}</button>
              ))}

              <div style={{position:"absolute",top:-18,right:10,background:`linear-gradient(135deg,${R.ruby},${R.crimson})`,color:"#fff",borderRadius:99,padding:"8px 18px",fontSize:12,fontWeight:600,boxShadow:`0 8px 24px rgba(192,57,43,.4)`,whiteSpace:"nowrap",animation:"floatR 3.5s ease-in-out infinite",fontFamily:"'Sora',sans-serif"}}>
                🎯 Next Batch: June 1
              </div>
              <div style={{position:"absolute",bottom:-18,left:10,background:`linear-gradient(135deg,${R.gold},#B8860B)`,color:"#fff",borderRadius:99,padding:"8px 18px",fontSize:12,fontWeight:600,boxShadow:`0 8px 24px rgba(212,160,23,.4)`,whiteSpace:"nowrap",animation:"float 4s ease-in-out infinite .8s",fontFamily:"'Sora',sans-serif"}}>
                👑 15,000+ Placed
              </div>

              <div style={{display:"flex",justifyContent:"center",gap:8,marginTop:36}}>
                {HERO_CARDS.map((_,i)=>(
                  <button key={i} onClick={()=>setCardIdx(i)} style={{width:i===cardIdx?28:8,height:8,borderRadius:99,border:"none",background:i===cardIdx?R.crimson:"rgba(192,57,43,.2)",cursor:"pointer",transition:"all .3s",padding:0}} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── COMPANY TICKER WITH LOGOS ─────────────────────────────────────────────────
function CompanyTicker() {
  const [hoveredLogo,setHoveredLogo]=useState(null);
  
  return (
    <div style={{borderTop:`1px solid rgba(246, 242, 242, 0.1)`,borderBottom:`1px solid rgba(192,57,43,.1)`,background:R.parchment,padding:"20px 32px",overflow:"hidden",fontFamily:"'Sora',sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",gap:20, maxWidth: 1300, margin: "0 auto"}}>
        
        <div style={{flexShrink:0,paddingRight: 24,fontSize:11,fontWeight:600,letterSpacing:".14em",color:R.crimson,textTransform:"uppercase",whiteSpace:"nowrap",fontFamily:"'Sora',sans-serif"}}>
          Our Alumni At
        </div>
        
        <div className="ticker-wrap" style={{flex:1, overflow: "hidden"}}>
          <div className="ticker-inner">
            {[...COMPANIES,...COMPANIES].map((c,i)=>(
              <div key={i} style={{display:"inline-flex",alignItems:"center",marginRight:48,cursor:"pointer",transition:"all .3s"}}
                onMouseEnter={()=>setHoveredLogo(i)}
                onMouseLeave={()=>setHoveredLogo(null)}
              >
                <div className="company-logo-wrapper" style={{
                  width:100,
                  height:40,
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center",
                  background:hoveredLogo===i?"rgba(192,57,43,.08)":"rgba(192,57,43,.02)",
                  borderRadius:10,
                  padding:"8px 12px",
                  border:`1px solid ${hoveredLogo===i?"rgba(192,57,43,.2)":"transparent"}`,
                  transition:"all .3s"
                }}>
                  <img src={c.logo} alt={c.name} style={{
                    maxWidth:"90%",
                    maxHeight:"90%",
                    objectFit:"contain"
                  }} onError={e=>e.target.style.display="none"} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── UNIVERSITY TICKER ─────────────────────────────────────────────────────────
function UniversityTicker() {
  const [hoveredLogo, setHoveredLogo] = useState(null);
  
  return (
    <div style={{borderBottom:`1px solid rgba(192,57,43,.1)`, background:R.parchment, padding:"30px 32px", overflow:"hidden", fontFamily:"'Sora',sans-serif"}}>
      
      <div style={{display:"flex", alignItems:"center", gap:20, maxWidth: 1300, margin: "0 auto"}}>
        
        <div style={{flexShrink:0, paddingRight: 24, fontSize:12, fontWeight:700, letterSpacing:".14em", color:R.crimson, textTransform:"uppercase", whiteSpace:"nowrap", fontFamily:"'Sora',sans-serif"}}>
          Partner Universities
        </div>
        
        <div className="ticker-wrap" style={{flex:1, overflow: "hidden"}}>
          <div className="ticker-inner" style={{ animationDirection: "reverse" }}>
            {[...UNIVERSITIES,...UNIVERSITIES].map((u,i)=>(
              <div key={i} style={{display:"inline-flex", alignItems:"center", marginRight:48, cursor:"pointer", transition:"all .3s"}}
                onMouseEnter={()=>setHoveredLogo(i)}
                onMouseLeave={()=>setHoveredLogo(null)}
              >
                <div style={{
                  width: 200,    // <-- Updated to 200px
                  height: 80,    // <-- Updated to 80px
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: hoveredLogo===i ? "rgba(192,57,43,.08)" : "rgba(192,57,43,.02)",
                  borderRadius: 12,
                  padding: "10px 16px",
                  border: `1px solid ${hoveredLogo===i ? "rgba(192,57,43,.2)" : "transparent"}`,
                  transition: "all .3s",
                  transform: hoveredLogo===i ? "scale(1.08)" : "scale(1)"
                }}>
                  <img src={u.logo} alt={u.name} style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain"
                  }} onError={e=>e.target.style.display="none"} />
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

// ── STATS BAR (dark section) ──────────────────────────────────────────────────
function StatsBar() {
  return (
    <section className="section-dark" style={{padding:"72px 32px",position:"relative",overflow:"hidden",fontFamily:"'Sora',sans-serif"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:`repeating-linear-gradient(45deg,rgba(192,57,43,.04) 0px,rgba(192,57,43,.04) 1px,transparent 1px,transparent 40px)`,pointerEvents:"none"}} />
      <div style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:700,height:300,borderRadius:"50%",background:`radial-gradient(ellipse,rgba(192,57,43,.15) 0%,transparent 70%)`,pointerEvents:"none"}} />

      <div style={{maxWidth:1100,margin:"0 auto",position:"relative"}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <div className="ornament" style={{fontFamily:"'Sora',sans-serif"}}>Our Impact in Numbers</div>
        </div>
        <div className="stats-row" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:24}}>
          {STATS.map((s,i)=>(
            <div key={s.label} style={{textAlign:"center",padding:"32px 20px",borderRadius:20,background:"rgba(192,57,43,.1)",border:"1px solid rgba(192,57,43,.2)",position:"relative",overflow:"hidden",animation:`fadeUp .6s ease ${i*.1}s both`,transition:"all .3s",cursor:"default",fontFamily:"'Sora',sans-serif"}}
              onMouseEnter={e=>{e.currentTarget.style.background="rgba(192,57,43,.18)";e.currentTarget.style.transform="translateY(-6px)";e.currentTarget.style.boxShadow=`0 20px 50px rgba(0,0,0,.4)`;}}
              onMouseLeave={e=>{e.currentTarget.style.background="rgba(192,57,43,.1)";e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none";}}
            >
              <div style={{fontSize:36,marginBottom:12}}>{s.icon}</div>
              <div className="ff-display" style={{fontSize:"clamp(28px,3.5vw,44px)",fontWeight:700,color:"#fff",lineHeight:1,fontFamily:"'Sora',sans-serif"}}>{s.val}</div>
              <div style={{color:"rgba(245,230,230,.55)",fontSize:13,marginTop:8,fontWeight:500,fontFamily:"'Sora',sans-serif"}}>{s.label}</div>
              <div style={{position:"absolute",bottom:0,left:0,right:0,height:3,background:`linear-gradient(90deg,transparent,${R.crimson},transparent)`}} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── WHY US (light) ────────────────────────────────────────────────────────────
function WhyUs() {
  return (
    <section className="section-white" style={{padding:"100px 32px",position:"relative",fontFamily:"'Sora',sans-serif"}}>
      <div style={{position:"absolute",top:0,left:0,right:0,height:4,background:`linear-gradient(90deg,${R.ruby},${R.crimson},${R.gold},${R.crimson},${R.ruby})`,backgroundSize:"200% 100%",animation:"shimmer 4s infinite linear"}} />
      <div style={{maxWidth:1300,margin:"0 auto"}}>
        <div style={{textAlign:"center",marginBottom:64}}>
          <div className="section-label-light" style={{fontFamily:"'Sora',sans-serif"}}>Why Techvanto Academy</div>
          <h2 className="ff-display" style={{fontSize:"clamp(30px,4.5vw,52px)",fontWeight:700,color:R.dark,letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>Accelerate with Techvanto Academy</h2>
          <p style={{color:"#8B4444",fontSize:16,maxWidth:520,margin:"14px auto 0",lineHeight:1.8,fontFamily:"'Sora',sans-serif"}}>What makes us the #1 choice for tech career transitions in India.</p>
        </div>
        <div className="why-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:20}}>
          {WHY_US.map(p=>(
            <div key={p.title} className="why-card" style={{fontFamily:"'Sora',sans-serif"}}>
              <div style={{display:"flex",gap:16,alignItems:"flex-start"}}>
                <div style={{width:52,height:52,borderRadius:14,background:`rgba(192,57,43,.08)`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0,border:`1px solid rgba(192,57,43,.15)`,transition:"all .3s"}}>
                  {p.icon}
                </div>
                <div>
                  <h3 className="ff-display" style={{fontWeight:700,fontSize:17,color:R.dark,marginBottom:8,fontFamily:"'Sora',sans-serif"}}>{p.title}</h3>
                  <p style={{color:"#6B3030",fontSize:14,lineHeight:1.75,fontFamily:"'Sora',sans-serif"}}>{p.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── COURSES (parchment) ───────────────────────────────────────────────────────
function CourseCard({ course: c }) {
  const [hov,setHov]=useState(false);
  const courseLinks = { 1: "/#/all-courses/college" };
  const link = courseLinks[c.id] || null;
  const handleCardClick = () => { if (link) window.location.href = link; };
  return (
    <div className="course-card" onClick={handleCardClick} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)} style={{display:"flex",flexDirection:"column",fontFamily:"'Sora',sans-serif",cursor:link?"pointer":"default"}}>
      <div style={{position:"relative",overflow:"hidden"}}>
        <img src={c.image} alt={c.title} style={{width:"100%",height:185,objectFit:"cover",display:"block",transition:"transform .5s ease",transform:hov?"scale(1.08)":"scale(1)"}} />
        <div style={{position:"absolute",inset:0,background:`linear-gradient(to top,rgba(139,0,0,.55) 0%,transparent 55%)`}} />
        {c.badge&&(
          <div className="shimmer-badge" style={{position:"absolute",top:12,left:12,color:"#fff",fontSize:10.5,fontWeight:600,padding:"4px 12px",borderRadius:99,letterSpacing:".04em",fontFamily:"'Sora',sans-serif"}}>{c.badge}</div>
        )}
        <div style={{position:"absolute",top:12,right:12,background:"rgba(255,255,255,.95)",borderRadius:10,padding:"5px 10px",display:"flex",alignItems:"center",gap:5,boxShadow:"0 2px 8px rgba(0,0,0,.1)",fontFamily:"'Sora',sans-serif"}}>
          <Stars rating={c.rating} />
          <span style={{fontSize:12,fontWeight:600,color:R.dark,fontFamily:"'Sora',sans-serif"}}>{c.rating}</span>
          <span style={{fontSize:11,color:"#999",fontFamily:"'Sora',sans-serif"}}>({c.reviews.toLocaleString()})</span>
        </div>
        <div style={{position:"absolute",bottom:12,left:14,fontSize:26}}>{c.icon}</div>
      </div>

      <div style={{padding:"20px 20px 0",position:"relative",zIndex:1,fontFamily:"'Sora',sans-serif"}}>
        <div style={{fontSize:11,fontWeight:600,color:R.crimson,marginBottom:6,letterSpacing:".05em",textTransform:"uppercase",fontFamily:"'Sora',sans-serif"}}>{c.tech}</div>
        <h3 className="ff-display" style={{fontSize:17,fontWeight:700,color:R.dark,marginBottom:12,lineHeight:1.3,fontFamily:"'Sora',sans-serif"}}>{c.title}</h3>
        <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:14}}>
          {c.tags.map(t=>(
            <span key={t} style={{background:`rgba(192,57,43,.08)`,color:R.crimson,fontSize:11,fontWeight:600,padding:"3px 10px",borderRadius:99,border:`1px solid rgba(192,57,43,.15)`,fontFamily:"'Sora',sans-serif"}}>{t}</span>
          ))}
        </div>
        <div style={{display:"flex",gap:14,marginBottom:14,fontFamily:"'Sora',sans-serif"}}>
          <span style={{fontSize:11.5,color:"#8B4444",fontFamily:"'Sora',sans-serif"}}>⏱ {c.duration}</span>
          <span style={{fontSize:11.5,color:"#8B4444",fontFamily:"'Sora',sans-serif"}}>👥 {c.students}</span>
          <span style={{fontSize:11.5,color:"#8B4444",fontFamily:"'Sora',sans-serif"}}>📶 {c.level}</span>
        </div>
      </div>

      <div style={{marginTop:"auto",padding:"0 20px 20px",position:"relative",zIndex:1,fontFamily:"'Sora',sans-serif"}}>
        <div style={{borderTop:`1px solid rgba(192,57,43,.1)`,paddingTop:16,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <div className="ff-display" style={{fontWeight:700,fontSize:22,color:R.dark,fontFamily:"'Sora',sans-serif"}}>{c.price}</div>
            <div style={{fontSize:12,color:"#BBB",textDecoration:"line-through",fontFamily:"'Sora',sans-serif"}}>{c.original}</div>
          </div>
          <button className="btn-royal" style={{padding:"10px 20px",borderRadius:10,fontSize:13,color:"#fff",transform:hov?"scale(1.06)":"scale(1)",transition:"transform .25s",fontFamily:"'Sora',sans-serif"}}>Apply Now →</button>
        </div>
      </div>
    </div>
  );
}

function CoursesSection() {
  const [filter,setFilter]=useState("All");
  const [showAll,setShowAll]=useState(false);
  const categories=["All","Development","AI & Data","Cloud & Security","Mobile & IoT","Hardware","Design"];
  const filterMap={"All":null,"Development":[1,6],"AI & Data":[2,3,8],"Cloud & Security":[4,5],"Mobile & IoT":[6,9,10,11],"Hardware":[11,12],"Design":[7]};
  const filtered=filter==="All"?COURSES:COURSES.filter(c=>filterMap[filter]?.includes(c.id));
  const visible=showAll?filtered:filtered.slice(0,6);

  return (
    <section id="courses" className="section-parchment" style={{padding:"100px 32px",fontFamily:"'Sora',sans-serif"}}>
      <div style={{maxWidth:1300,margin:"0 auto"}}>
        <div style={{textAlign:"center",marginBottom:56}}>
          <div className="section-label-light" style={{fontFamily:"'Sora',sans-serif"}}>All Courses</div>
          <h2 className="ff-display" style={{fontSize:"clamp(30px,4.5vw,52px)",fontWeight:700,color:R.dark,letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>Tech Programs for Every Career Path</h2>
          <p style={{color:"#8B4444",fontSize:16,maxWidth:540,margin:"14px auto 32px",lineHeight:1.8,fontFamily:"'Sora',sans-serif"}}>Industry-standard curriculum built by top tech companies.</p>
          <div style={{display:"flex",justifyContent:"center",gap:10,flexWrap:"wrap"}}>
            {categories.map(cat=>(
              <button key={cat} onClick={()=>{setFilter(cat);setShowAll(false);}}
                style={{padding:"8px 22px",borderRadius:99,fontWeight:600,fontSize:13,cursor:"pointer",border:"2px solid",transition:"all .25s",fontFamily:"'Sora',sans-serif",background:filter===cat?`linear-gradient(135deg,${R.crimson},${R.ruby})`:"rgba(255,255,255,.8)",borderColor:filter===cat?R.crimson:"rgba(192,57,43,.2)",color:filter===cat?"#fff":R.crimson,boxShadow:filter===cat?`0 6px 20px rgba(192,57,43,.35)`:"none",transform:filter===cat?"translateY(-2px)":"none"}}>
                {cat}
              </button>
            ))}
          </div>
        </div>
        <div className="courses-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:22}}>
          {visible.map(c=><CourseCard key={c.id} course={c} />)}
        </div>
        {filtered.length>6&&(
          <div style={{textAlign:"center",marginTop:48}}>
            <button onClick={()=>setShowAll(s=>!s)} className="btn-royal ff-display" style={{color:"#fff",padding:"14px 42px",borderRadius:12,fontSize:15,fontFamily:"'Sora',sans-serif"}}>
              {showAll?`Show Less ▲`:`See All ${filtered.length} Courses ▼`}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

// ── PROGRAMS (dark) ───────────────────────────────────────────────────────────
function ProgramsSection() {
  const [active,setActive]=useState(0);
  const prog=PROGRAMS[active];
  return (
    <section id="programs" className="section-dark" style={{padding:"100px 32px",position:"relative",fontFamily:"'Sora',sans-serif"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:`radial-gradient(ellipse 60% 80% at 50% 50%,rgba(192,57,43,.12) 0%,transparent 70%)`,pointerEvents:"none"}} />
      <div style={{maxWidth:1300,margin:"0 auto",position:"relative"}}>
        <div style={{textAlign:"center",marginBottom:56}}>
          <div className="section-label-dark" style={{fontFamily:"'Sora',sans-serif"}}>Programs</div>
          <h2 className="ff-display" style={{fontSize:"clamp(30px,4.5vw,52px)",fontWeight:700,color:"#fff",letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>Next-level growth for seasoned professionals</h2>
          <p style={{color:"rgba(245,230,230,.5)",fontSize:16,maxWidth:520,margin:"14px auto 0",lineHeight:1.8,fontFamily:"'Sora',sans-serif"}}>Industry-designed programs with mentor support, real projects, and guaranteed placement.</p>
        </div>

        <div style={{display:"flex",borderBottom:`1px solid rgba(192,57,43,.2)`,marginBottom:44,justifyContent:"center",flexWrap:"wrap",fontFamily:"'Sora',sans-serif"}}>
          {PROGRAMS.map((p,i)=>(
            <button key={i} onClick={()=>setActive(i)}
              style={{padding:"11px 28px",border:"none",borderBottom:active===i?`2px solid ${R.crimson}`:"2px solid transparent",background:"none",color:active===i?"#F1948A":"rgba(245,230,230,.45)",fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:"'Sora',sans-serif",transition:"all .2s"}}>
              {p.tag}
            </button>
          ))}
        </div>

        <div className="programs-split" key={active} style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:56,alignItems:"center",animation:"fadeUp .4s ease",fontFamily:"'Sora',sans-serif"}}>
          <div>
            <div style={{display:"inline-block",background:`rgba(192,57,43,.2)`,border:`1px solid rgba(192,57,43,.4)`,borderRadius:6,padding:"4px 13px",fontSize:11,fontWeight:600,color:"#F1948A",letterSpacing:2,marginBottom:20,fontFamily:"'Sora',sans-serif"}}>{prog.badge}</div>
            <h3 className="ff-display" style={{fontSize:"clamp(26px,3.5vw,40px)",fontWeight:700,color:"#fff",marginBottom:10,letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>{prog.title}</h3>
            <p style={{color:"rgba(245,230,230,.5)",fontSize:16,marginBottom:32,fontFamily:"'Sora',sans-serif"}}>{prog.subtitle}</p>

            <div style={{display:"flex",gap:14,marginBottom:32,flexWrap:"wrap"}}>
              {[["📅","Duration",prog.duration],["💻","Mode",prog.mode]].map(([ic,lb,vl])=>(
                <div key={lb} style={{flex:1,minWidth:140,background:"rgba(192,57,43,.08)",border:`1px solid rgba(192,57,43,.18)`,borderRadius:14,padding:"16px 18px",fontFamily:"'Sora',sans-serif"}}>
                  <div style={{fontSize:20,marginBottom:4}}>{ic}</div>
                  <div style={{fontSize:11,color:"rgba(245,230,230,.35)",marginBottom:3,fontFamily:"'Sora',sans-serif"}}>{lb}</div>
                  <div className="ff-display" style={{fontSize:15,fontWeight:700,color:"#fff",fontFamily:"'Sora',sans-serif"}}>{vl}</div>
                </div>
              ))}
            </div>

            {prog.highlights.map(h=>(
              <div key={h} style={{display:"flex",gap:12,alignItems:"flex-start",marginBottom:14,fontFamily:"'Sora',sans-serif"}}>
                <span style={{color:R.crimson,fontSize:16,flexShrink:0,marginTop:2}}>✦</span>
                <span style={{fontSize:15,color:"rgba(245,230,230,.7)",lineHeight:1.55,fontFamily:"'Sora',sans-serif"}}>{h}</span>
              </div>
            ))}

            <div style={{display:"flex",gap:12,flexWrap:"wrap",marginTop:32}}>
              <button className="btn-royal" style={{color:"#fff",padding:"13px 28px",borderRadius:11,fontSize:15,fontFamily:"'Sora',sans-serif"}}>Apply Now →</button>
              <button className="btn-outline-royal" style={{padding:"13px 26px",borderRadius:11,fontSize:15,color:R.crimson,border:`2px solid ${R.crimson}`,fontFamily:"'Sora',sans-serif"}}
                onMouseEnter={e=>e.currentTarget.querySelector('span').style.color='#fff'}
                onMouseLeave={e=>e.currentTarget.querySelector('span').style.color=R.crimson}
              >
                <span style={{transition:"color .3s"}}>Download Syllabus</span>
              </button>
            </div>
          </div>

          <div style={{display:"flex",justifyContent:"center"}}>
            <div style={{borderRadius:24,padding:36,width:"100%",maxWidth:360,background:`rgba(61,21,21,.7)`,border:`1px solid rgba(192,57,43,.25)`,textAlign:"center",boxShadow:`0 0 60px rgba(192,57,43,.1)`,fontFamily:"'Sora',sans-serif"}}>
              <div style={{width:80,height:80,borderRadius:22,background:`linear-gradient(135deg,${R.crimson},${R.ruby})`,margin:"0 auto 24px",display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,boxShadow:`0 12px 32px rgba(192,57,43,.4)`,animation:"heartbeat 3s infinite"}}>{prog.icon}</div>
              <h4 className="ff-display" style={{fontSize:18,fontWeight:700,marginBottom:8,color:"#fff",fontFamily:"'Sora',sans-serif"}}>{prog.tag}</h4>
              <p style={{fontSize:13,color:"rgba(245,230,230,.4)",marginBottom:24,fontFamily:"'Sora',sans-serif"}}>{prog.duration} • {prog.mode}</p>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                {[["Projects","10+"],["Mentors","20+"],["Live Classes","80+"],["Placement","100%"]].map(([l,v])=>(
                  <div key={l} style={{background:"rgba(192,57,43,.08)",borderRadius:12,padding:"14px 8px",border:`1px solid rgba(192,57,43,.15)`,fontFamily:"'Sora',sans-serif"}}>
                    <div className="ff-display" style={{fontWeight:700,fontSize:20,color:R.crimson,fontFamily:"'Sora',sans-serif"}}>{v}</div>
                    <div style={{fontSize:11,color:"rgba(245,230,230,.4)",marginTop:2,fontFamily:"'Sora',sans-serif"}}>{l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── TECH STACK (white) ────────────────────────────────────────────────────────
function TechStack() {
  const [active,setActive]=useState(0);
  const [hov,setHov]=useState(null);
  return (
    <section className="section-white" style={{padding:"100px 32px",fontFamily:"'Sora',sans-serif"}}>
      <div style={{maxWidth:1300,margin:"0 auto"}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <div className="section-label-light" style={{fontFamily:"'Sora',sans-serif"}}>Tech Stack</div>
          <h2 className="ff-display" style={{fontSize:"clamp(30px,4.5vw,52px)",fontWeight:700,color:R.dark,letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>Tools & Technologies You'll Master</h2>
          <p style={{color:"#8B4444",fontSize:16,maxWidth:480,margin:"14px auto 0",lineHeight:1.8,fontFamily:"'Sora',sans-serif"}}>The complete modern tech ecosystem — from frontend to AI to cloud to IoT.</p>
        </div>
        <div style={{display:"flex",justifyContent:"center",gap:10,flexWrap:"wrap",marginBottom:40}}>
          {TECH_STACK.map((t,i)=>(
            <button key={t.category} onClick={()=>{setActive(i);setHov(null);}}
              style={{padding:"8px 22px",borderRadius:99,fontWeight:600,fontSize:13,cursor:"pointer",border:"2px solid",transition:"all .25s",fontFamily:"'Sora',sans-serif",background:active===i?`linear-gradient(135deg,${R.crimson},${R.ruby})`:"transparent",borderColor:active===i?R.crimson:"rgba(192,57,43,.25)",color:active===i?"#fff":R.crimson,boxShadow:active===i?`0 6px 20px rgba(192,57,43,.3)`:"none"}}>
              {t.category}
            </button>
          ))}
        </div>
        <div className="tech-grid" style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:16}}>
          {TECH_STACK[active].items.map((tech,i)=>(
            <div key={tech.name} onMouseEnter={()=>setHov(i)} onMouseLeave={()=>setHov(null)}
              style={{display:"flex",flexDirection:"column",alignItems:"center",gap:10,padding:"24px 12px 20px",borderRadius:18,border:`1.5px solid ${hov===i?"rgba(192,57,43,.4)":"rgba(192,57,43,.1)"}`,background:hov===i?"rgba(192,57,43,.05)":"#fff",boxShadow:hov===i?`0 12px 36px rgba(192,57,43,.14)`:"0 2px 8px rgba(0,0,0,.04)",transition:"all .3s",transform:hov===i?"translateY(-8px) scale(1.04)":"none",cursor:"default",fontFamily:"'Sora',sans-serif"}}>
              <div style={{width:58,height:58,display:"flex",alignItems:"center",justifyContent:"center",borderRadius:14,background:hov===i?"rgba(192,57,43,.08)":"rgba(0,0,0,.03)",border:`1px solid ${hov===i?"rgba(192,57,43,.2)":"rgba(0,0,0,.06)"}`,transition:"all .3s"}}>
                <img src={tech.logo} alt={tech.name} style={{width:36,height:36,objectFit:"contain",transition:"transform .3s",transform:hov===i?"scale(1.15) rotate(-5deg)":"scale(1)"}} onError={e=>e.target.style.display="none"} />
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:12.5,fontWeight:600,color:hov===i?R.crimson:R.dark,transition:"color .25s",fontFamily:"'Sora',sans-serif"}}>{tech.name}</div>
                {hov===i&&<div style={{fontSize:9.5,color:R.crimson,fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",marginTop:2,fontFamily:"'Sora',sans-serif"}}>Expert</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── PROCESS (light section) ───────────────────────────────────────────────────
function ProcessSection() {
  return (
    <section className="section-white" style={{padding:"100px 32px",position:"relative",fontFamily:"'Sora',sans-serif"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:`radial-gradient(ellipse 80% 60% at 20% 40%,rgba(192,57,43,.05) 0%,transparent 60%), radial-gradient(ellipse 60% 50% at 80% 70%,rgba(212,160,23,.04) 0%,transparent 60%)`,pointerEvents:"none"}} />
      <div style={{maxWidth:1300,margin:"0 auto",position:"relative"}}>
        <div style={{textAlign:"center",marginBottom:68}}>
          <div className="section-label-light" style={{fontFamily:"'Sora',sans-serif"}}>Our Methodology</div>
          <h2 className="ff-display" style={{fontSize:"clamp(30px,4.5vw,52px)",fontWeight:700,color:R.dark,letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>How You'll Learn & Grow</h2>
          <p style={{color:"#8B4444",fontSize:16,maxWidth:500,margin:"14px auto 0",lineHeight:1.8,fontFamily:"'Sora',sans-serif"}}>A 6-step proven process designed for maximum career impact.</p>
        </div>
        <div className="process-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:20}}>
          {PROCESS.map((step)=>(
            <div key={step.n} className="process-card-light" style={{fontFamily:"'Sora',sans-serif"}}>
              <div style={{position:"absolute",top:16,right:18,fontFamily:"'Sora',sans-serif",fontSize:64,fontWeight:700,color:"rgba(192,57,43,.08)",lineHeight:1,pointerEvents:"none"}}>{step.n}</div>
              <div style={{width:52,height:52,borderRadius:14,background:`rgba(192,57,43,.1)`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,marginBottom:20,border:`1px solid rgba(192,57,43,.2)`}}>{step.icon}</div>
              <span style={{fontSize:10.5,fontWeight:700,color:R.crimson,background:`rgba(192,57,43,.08)`,padding:"3px 11px",borderRadius:99,display:"inline-block",marginBottom:12,letterSpacing:".06em",fontFamily:"'Sora',sans-serif"}}>STEP {step.n}</span>
              <h3 className="ff-display" style={{fontWeight:700,fontSize:16,color:R.dark,marginBottom:10,fontFamily:"'Sora',sans-serif"}}>{step.title}</h3>
              <p style={{color:"#6B3030",fontSize:14,lineHeight:1.8,fontFamily:"'Sora',sans-serif"}}>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── MENTORS (cream) ───────────────────────────────────────────────────────────
function MentorsSection() {
  const [hov,setHov]=useState(null);
  return (
    <section id="mentors" className="section-cream" style={{padding:"100px 32px",background:R.cream,fontFamily:"'Sora',sans-serif"}}>
      <div style={{maxWidth:1300,margin:"0 auto"}}>
        <div style={{textAlign:"center",marginBottom:60}}>
          <div className="section-label-light" style={{fontFamily:"'Sora',sans-serif"}}>Mentors & Instructors</div>
          <h2 className="ff-display" style={{fontSize:"clamp(30px,4.5vw,52px)",fontWeight:700,color:R.dark,letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>Learn from FAANG Engineers</h2>
          <p style={{color:"#8B4444",fontSize:16,maxWidth:500,margin:"14px auto 0",lineHeight:1.8,fontFamily:"'Sora',sans-serif"}}>Senior engineers with a passion for teaching and mentorship.</p>
        </div>
        <div className="mentors-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:20}}>
          {MENTORS.map((m,i)=>(
            <div key={m.name} className="mentor-card" onMouseEnter={()=>setHov(i)} onMouseLeave={()=>setHov(null)} style={{fontFamily:"'Sora',sans-serif"}}>
              <div style={{display:"flex",gap:16,alignItems:"center"}}>
                <div style={{flexShrink:0,position:"relative"}}>
                  <img src={m.img} alt={m.name} style={{width:62,height:62,borderRadius:"50%",objectFit:"cover",border:`3px solid ${hov===i?R.crimson:"rgba(192,57,43,.2)"}`,boxShadow:hov===i?`0 0 20px rgba(192,57,43,.3)`:"none",transition:"all .3s"}} />
                  <div style={{position:"absolute",bottom:1,right:1,width:14,height:14,borderRadius:"50%",background:"#27AE60",border:"2px solid #fff"}} />
                </div>
                <div>
                  <div className="ff-display" style={{fontWeight:700,fontSize:15,color:R.dark,marginBottom:3,fontFamily:"'Sora',sans-serif"}}>{m.name}</div>
                  <div style={{fontSize:13,color:R.crimson,fontWeight:600,marginBottom:3,fontFamily:"'Sora',sans-serif"}}>{m.role}</div>
                  <div style={{fontSize:12,color:"#8B4444",fontFamily:"'Sora',sans-serif"}}>{m.exp} Experience</div>
                </div>
              </div>
              {hov===i&&(
                <div style={{marginTop:14,paddingTop:14,borderTop:`1px solid rgba(192,57,43,.1)`,display:"flex",gap:8,animation:"fadeUp .2s ease",fontFamily:"'Sora',sans-serif"}}>
                  {["React","System Design","ML"].slice(0,2).map(tag=>(
                    <span key={tag} style={{background:`rgba(192,57,43,.08)`,color:R.crimson,fontSize:11,fontWeight:600,padding:"3px 10px",borderRadius:99,fontFamily:"'Sora',sans-serif"}}>{tag}</span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── ALUMNI (dark) ─────────────────────────────────────────────────────────────
function AlumniSection() {
  const [current,setCurrent]=useState(0);
  const timerRef=useRef(null);

  const go=(i)=>{
    clearInterval(timerRef.current);
    setCurrent(i);
    timerRef.current=setInterval(()=>setCurrent(c=>(c+1)%ALUMNI.length),4000);
  };

  useEffect(()=>{
    timerRef.current=setInterval(()=>setCurrent(c=>(c+1)%ALUMNI.length),4000);
    return ()=>clearInterval(timerRef.current);
  },[]);

  const visible=[ALUMNI[current%ALUMNI.length],ALUMNI[(current+1)%ALUMNI.length],ALUMNI[(current+2)%ALUMNI.length]];

  return (
    <section id="placements" className="section-dark" style={{padding:"100px 32px",position:"relative",overflow:"hidden",fontFamily:"'Sora',sans-serif"}}>
      <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse 70% 60% at 50% 50%,rgba(192,57,43,.08) 0%,transparent 65%)`,pointerEvents:"none"}} />
      <div style={{maxWidth:1300,margin:"0 auto",position:"relative"}}>
        <div style={{textAlign:"center",marginBottom:60}}>
          <div className="section-label-dark" style={{fontFamily:"'Sora',sans-serif"}}>Alumni Success</div>
          <h2 className="ff-display" style={{fontSize:"clamp(30px,4.5vw,52px)",fontWeight:700,color:"#fff",letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>Our Alumni Work at the World's Best Companies</h2>
          <p style={{color:"rgba(245,230,230,.5)",fontSize:16,maxWidth:540,margin:"14px auto 0",lineHeight:1.8,fontFamily:"'Sora',sans-serif"}}>92% of graduates land roles within 4 months, with an average salary of ₹28 LPA.</p>
        </div>

        <div className="alumni-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:18,marginBottom:28}}>
          {visible.map((a,i)=>(
            <div key={a.name+i} style={{borderRadius:20,padding:"26px 22px",background:i===1?"rgba(80,20,20,.85)":"rgba(44,15,15,.5)",border:`1.5px solid ${i===1?"rgba(192,57,43,.45)":"rgba(192,57,43,.15)"}`,transition:"all .36s ease",transform:i===1?"scale(1.03)":"scale(1)",boxShadow:i===1?`0 24px 64px rgba(0,0,0,.4), 0 0 40px rgba(192,57,43,.1)`:"none",fontFamily:"'Sora',sans-serif"}}>
              <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:16}}>
                <img src={a.img} alt={a.name} style={{width:52,height:52,borderRadius:"50%",objectFit:"cover",border:`2px solid ${i===1?R.crimson:"rgba(192,57,43,.3)"}`}} />
                <div>
                  <h3 className="ff-display" style={{fontWeight:700,fontSize:15,color:"#fff",marginBottom:2,fontFamily:"'Sora',sans-serif"}}>{a.name}</h3>
                  <p style={{fontSize:12,color:"#F1948A",fontWeight:500,fontFamily:"'Sora',sans-serif"}}>{a.role} @ {a.company}</p>
                </div>
              </div>
              <p style={{fontSize:13.5,lineHeight:1.75,color:i===1?"rgba(245,230,230,.8)":"rgba(245,230,230,.5)",fontStyle:"italic",marginBottom:16,fontFamily:"'Sora',sans-serif"}}>"{a.quote}"</p>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{background:"rgba(192,57,43,.15)",color:"#F1948A",fontSize:11,fontWeight:600,padding:"4px 10px",borderRadius:99,fontFamily:"'Sora',sans-serif"}}>{a.course}</span>
                <span className="ff-display" style={{fontSize:14,fontWeight:700,color:R.gold,fontFamily:"'Sora',sans-serif"}}>{a.pkg}</span>
              </div>
            </div>
          ))}
        </div>

        <div style={{display:"flex",justifyContent:"center",gap:12,alignItems:"center"}}>
          <button onClick={()=>go((current-1+ALUMNI.length)%ALUMNI.length)} style={{width:40,height:40,borderRadius:"50%",border:`1px solid rgba(192,57,43,.3)`,background:"rgba(192,57,43,.1)",cursor:"pointer",fontSize:16,color:"#F1948A",transition:"all .2s",fontFamily:"'Sora',sans-serif"}}
            onMouseEnter={e=>{e.currentTarget.style.background=R.crimson;e.currentTarget.style.color="#fff";}}
            onMouseLeave={e=>{e.currentTarget.style.background="rgba(192,57,43,.1)";e.currentTarget.style.color="#F1948A";}}
          >‹</button>
          <div style={{display:"flex",gap:8}}>
            {ALUMNI.map((_,i)=>(
              <button key={i} onClick={()=>go(i)} style={{width:i===current?24:8,height:8,borderRadius:99,border:"none",background:i===current?R.crimson:"rgba(192,57,43,.25)",cursor:"pointer",transition:"all .3s",padding:0}} />
            ))}
          </div>
          <button onClick={()=>go((current+1)%ALUMNI.length)} style={{width:40,height:40,borderRadius:"50%",border:`1px solid rgba(192,57,43,.3)`,background:"rgba(192,57,43,.1)",cursor:"pointer",fontSize:16,color:"#F1948A",transition:"all .2s",fontFamily:"'Sora',sans-serif"}}
            onMouseEnter={e=>{e.currentTarget.style.background=R.crimson;e.currentTarget.style.color="#fff";}}
            onMouseLeave={e=>{e.currentTarget.style.background="rgba(192,57,43,.1)";e.currentTarget.style.color="#F1948A";}}
          >›</button>
        </div>
      </div>
    </section>
  );
}

// ── ABOUT (parchment + dark split) ────────────────────────────────────────────
function AboutSection() {
  const pillars=[
    {icon:"🎯",text:"Outcome-first curriculum — every lesson maps to a real job skill"},
    {icon:"🏗️",text:"Build 6–8 production-grade projects, not toy examples"},
    {icon:"🧑‍🏫",text:"Mentors who are active FAANG engineers, not retired teachers"},
    {icon:"📋",text:"Dedicated placement cell with 150+ hiring partner network"},
  ];
  return (
    <section id="about" className="section-parchment" style={{padding:"100px 32px",fontFamily:"'Sora',sans-serif"}}>
      <div style={{maxWidth:1300,margin:"0 auto"}}>
        <div className="story-split" style={{display:"grid",gridTemplateColumns:"1fr 1.1fr",gap:72,alignItems:"center"}}>
          <div style={{position:"relative"}}>
            <div style={{borderRadius:24,overflow:"hidden",boxShadow:`0 40px 100px rgba(192,57,43,.15)`}}>
              <img src="https://images.unsplash.com/photo-1531482615713-2afd69097998?w=640&h=720&fit=crop" alt="Students learning" style={{width:"100%",height:520,objectFit:"cover",display:"block"}} />
              <div style={{position:"absolute",inset:0,background:`linear-gradient(to top,rgba(139,0,0,.45) 0%,transparent 55%)`}} />
            </div>
            <div style={{position:"absolute",bottom:28,left:28,background:"rgba(255,255,255,.96)",borderRadius:18,padding:"16px 22px",backdropFilter:"blur(16px)",border:`1px solid rgba(192,57,43,.15)`,boxShadow:`0 8px 32px rgba(192,57,43,.12)`,fontFamily:"'Sora',sans-serif"}}>
              <div className="ff-display" style={{fontWeight:700,fontSize:28,color:R.crimson,lineHeight:1,fontFamily:"'Sora',sans-serif"}}>₹28 LPA</div>
              <div style={{fontSize:12,color:"#8B4444",marginTop:4,fontFamily:"'Sora',sans-serif"}}>Average Salary of Our Alumni</div>
            </div>
            <div style={{position:"absolute",top:28,right:-18,background:`linear-gradient(135deg,${R.crimson},${R.ruby})`,borderRadius:16,padding:"16px 20px",boxShadow:`0 12px 36px rgba(192,57,43,.4)`,textAlign:"center",animation:"floatR 3.5s ease-in-out infinite",fontFamily:"'Sora',sans-serif"}}>
              <div className="ff-display" style={{fontWeight:700,fontSize:24,color:"#fff",lineHeight:1,fontFamily:"'Sora',sans-serif"}}>6+</div>
              <div style={{fontSize:11,color:"rgba(255,255,255,.7)",marginTop:3,fontFamily:"'Sora',sans-serif"}}>Years of Excellence</div>
            </div>
          </div>

          <div>
            <div className="section-label-light" style={{fontFamily:"'Sora',sans-serif"}}>Our Story</div>
            <h2 className="ff-display" style={{fontSize:"clamp(28px,3.5vw,46px)",fontWeight:700,color:R.dark,lineHeight:1.15,marginBottom:24,letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>
              Built Because Good Talent Deserves{" "}
              <span style={{background:`linear-gradient(135deg,${R.crimson},${R.ruby})`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text"}}>Better Doors</span>
            </h2>
            <p style={{fontSize:15.5,color:"#6B3030",lineHeight:1.9,marginBottom:18,fontFamily:"'Sora',sans-serif"}}>
              In 2018, our founders — engineers from Google and IIT — watched brilliant students struggle to break into top tech roles, not because of a lack of talent, but because of a broken education system.
            </p>
            <p style={{fontSize:15.5,color:"#6B3030",lineHeight:1.9,marginBottom:28,fontFamily:"'Sora',sans-serif"}}>
              Techvanto Academy was built to fix exactly that. We partnered directly with hiring managers at FAANG companies to reverse-engineer what gets someone hired at ₹25–55 LPA.
            </p>
            <p style={{fontSize:15.5,color:"#4A2020",lineHeight:1.9,marginBottom:36,fontFamily:"'Sora',sans-serif"}}>
              Today, 15,000+ students later: <strong style={{color:R.crimson}}>you won't just learn tech — you'll become someone companies compete to hire.</strong>
            </p>

            <div style={{display:"flex",flexDirection:"column",gap:14,marginBottom:40}}>
              {pillars.map((p,i)=>(
                <div key={i} style={{display:"flex",alignItems:"flex-start",gap:14,fontFamily:"'Sora',sans-serif"}}>
                  <div style={{width:38,height:38,borderRadius:10,background:`rgba(192,57,43,.08)`,border:`1px solid rgba(192,57,43,.2)`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>{p.icon}</div>
                  <p style={{fontSize:14.5,color:"#6B3030",lineHeight:1.7,paddingTop:8,fontFamily:"'Sora',sans-serif"}}>{p.text}</p>
                </div>
              ))}
            </div>

            <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
              <a href="/#/all-courses/college" className="btn-royal" style={{color:"#fff",padding:"13px 28px",borderRadius:11,fontSize:14,textDecoration:"none",display:"inline-block",fontFamily:"'Sora',sans-serif"}}>Explore Programs →</a>
              
              <a 
                href="#contact" 
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }} 
                className="btn-outline-royal" 
                style={{padding:"13px 26px",borderRadius:11,fontSize:14,textDecoration:"none",display:"inline-block",background:"transparent",color:R.crimson,border:`2px solid ${R.crimson}`,fontFamily:"'Sora',sans-serif"}}
              >
                <span>Book Free Counselling</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── FAQ (white) ───────────────────────────────────────────────────────────────
function FAQ() {
  const [open,setOpen]=useState(null);
  return (
    <section className="section-white" style={{padding:"100px 32px",fontFamily:"'Sora',sans-serif"}}>
      <div style={{maxWidth:860,margin:"0 auto"}}>
        <div style={{textAlign:"center",marginBottom:56}}>
          <div className="section-label-light" style={{fontFamily:"'Sora',sans-serif"}}>FAQ</div>
          <h2 className="ff-display" style={{fontSize:"clamp(30px,4vw,48px)",fontWeight:700,color:R.dark,letterSpacing:"-.02em",fontFamily:"'Sora',sans-serif"}}>Frequently Asked Questions</h2>
          <p style={{color:"#8B4444",fontSize:16,marginTop:14,lineHeight:1.7,fontFamily:"'Sora',sans-serif"}}>Have questions? We've got answers.</p>
        </div>
        <div>
          {FAQS.map((faq,i)=>(
            <div key={i} className={`faq-item ${open===i?"faq-open":""}`} style={{fontFamily:"'Sora',sans-serif"}}>
              <button onClick={()=>setOpen(open===i?null:i)}
                style={{width:"100%",padding:"20px 24px",background:"none",border:"none",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",fontFamily:"'Sora',sans-serif"}}>
                <span style={{fontWeight:600,fontSize:15,color:R.dark,textAlign:"left",lineHeight:1.45,flex:1,marginRight:16,fontFamily:"'Sora',sans-serif"}}>{faq.q}</span>
                <div style={{width:32,height:32,borderRadius:"50%",background:open===i?R.crimson:"rgba(192,57,43,.08)",border:`1.5px solid ${open===i?R.crimson:"rgba(192,57,43,.2)"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all .3s",boxShadow:open===i?`0 4px 16px rgba(192,57,43,.35)`:"none"}}>
                  <span style={{color:open===i?"#fff":R.crimson,fontSize:18,display:"block",transform:open===i?"rotate(45deg)":"none",transition:"transform .3s",lineHeight:1}}>+</span>
                </div>
              </button>
              {open===i&&(
                <div style={{padding:"0 24px 20px",animation:"fadeUp .2s ease"}}>
                  <p style={{color:"#6B3030",fontSize:14.5,lineHeight:1.85,borderTop:`1px solid rgba(192,57,43,.1)`,paddingTop:16,fontFamily:"'Sora',sans-serif"}}>{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── CTA (dark) ────────────────────────────────────────────────────────────────
function CTASection() {
  const formRef = useRef(); // Reference for the form
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_pq585w9', 
        'template_tcketm8', 
        formRef.current, 
        'CB7Wsiv5o7N6OvmQ3'
      )
      .then(
        () => {
          setSubmitted(true);
          setTimeout(() => setSubmitted(false), 4000);
          
          if (formRef.current) {
            formRef.current.reset();
          }
        },
        (error) => {
          console.error('FAILED...', error.text);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <section id="contact" className="section-dark" style={{padding:"100px 32px",position:"relative",overflow:"hidden",fontFamily:"'Sora',sans-serif"}}>
      <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse 60% 70% at 30% 50%,rgba(192,57,43,.12) 0%,transparent 60%), radial-gradient(ellipse 50% 60% at 80% 30%,rgba(212,160,23,.06) 0%,transparent 55%)`,pointerEvents:"none"}} />
      <div style={{position:"absolute",inset:0,backgroundImage:`repeating-linear-gradient(-45deg,rgba(192,57,43,.03) 0px,rgba(192,57,43,.03) 1px,transparent 1px,transparent 24px)`,pointerEvents:"none"}} />
      <div style={{maxWidth:1300,margin:"0 auto",position:"relative"}}>
        <div className="cta-split" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:72,alignItems:"center"}}>
          <div>
            <div style={{display:"inline-flex",alignItems:"center",gap:8,background:"rgba(192,57,43,.15)",border:"1px solid rgba(192,57,43,.3)",borderRadius:99,padding:"7px 18px",marginBottom:28,fontFamily:"'Sora',sans-serif"}}>
              <span style={{width:8,height:8,borderRadius:"50%",background:R.crimson,display:"inline-block",animation:"pulse 1.8s infinite"}} />
              <span style={{fontSize:12.5,fontWeight:600,color:"#F1948A",fontFamily:"'Sora',sans-serif"}}>Enrollments Open — Limited Seats</span>
            </div>
            <h2 className="ff-display" style={{fontSize:"clamp(30px,4vw,52px)",fontWeight:700,color:"#fff",marginBottom:20,letterSpacing:"-.02em",lineHeight:1.12,fontFamily:"'Sora',sans-serif"}}>
              Ready to Launch Your<br />
              <span style={{background:`linear-gradient(135deg,${R.scarlet},${R.gold})`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text"}}>Tech Career?</span>
            </h2>
            <p style={{color:"rgba(245,230,230,.55)",fontSize:16,lineHeight:1.8,marginBottom:36,fontFamily:"'Sora',sans-serif"}}>
              Join 15,000+ students who've landed roles at Google, Amazon, Microsoft, and more.
            </p>
            {[["🎓","Free career counseling session"],["📋","Personalized learning roadmap"],["💰","Scholarship up to ₹20,000"],["🤝","Placement guarantee in writing"]].map(([ic,lb])=>(
              <div key={lb} style={{display:"flex",gap:12,alignItems:"center",marginBottom:14,fontFamily:"'Sora',sans-serif"}}>
                <span style={{fontSize:18}}>{ic}</span>
                <span style={{fontSize:14.5,color:"rgba(245,230,230,.65)",fontFamily:"'Sora',sans-serif"}}>{lb}</span>
              </div>
            ))}
            <div style={{display:"flex",gap:12,flexWrap:"wrap",marginTop:36}}>
              <a href="tel:+919646206032" className="btn-royal" style={{color:"#fff",padding:"15px 28px",borderRadius:12,fontSize:14.5,textDecoration:"none",display:"inline-block",fontFamily:"'Sora',sans-serif"}}>📞 Call: +91 96462 06032</a>
              <a href="mailto:info@techvanto.com" className="btn-gold" style={{color:"#fff",padding:"15px 26px",borderRadius:12,fontSize:14.5,textDecoration:"none",display:"inline-block",fontFamily:"'Sora',sans-serif"}}>📧 Email Us</a>
            </div>
          </div>

          <div style={{background:"rgba(61,21,21,.6)",border:"1px solid rgba(192,57,43,.25)",borderRadius:24,padding:"40px 36px",backdropFilter:"blur(20px)",boxShadow:"0 32px 80px rgba(0,0,0,.3)",fontFamily:"'Sora',sans-serif"}}>
            {submitted ? (
              <div style={{textAlign:"center",padding:"40px 0"}}>
                <div style={{fontSize:64,marginBottom:16,animation:"stampIn .5s ease"}}>🎉</div>
                <h3 className="ff-display" style={{fontSize:22,fontWeight:700,marginBottom:10,color:"#fff",fontFamily:"'Sora',sans-serif"}}>You're All Set!</h3>
                <p style={{fontSize:15,color:"rgba(245,230,230,.55)",fontFamily:"'Sora',sans-serif"}}>Our counselor will call you within 30 minutes.</p>
              </div>
            ) : (
              <form ref={formRef} onSubmit={handleSubmit} style={{display:"flex",flexDirection:"column",gap:12}}>
                <div style={{height:3,background:`linear-gradient(90deg,${R.ruby},${R.crimson},${R.gold})`,borderRadius:99,marginBottom:28,animation:"shimmer 3s infinite linear",backgroundSize:"200% 100%"}} />
                <h3 className="ff-display" style={{fontSize:22,fontWeight:700,marginBottom:6,color:"#fff",fontFamily:"'Sora',sans-serif"}}>Book a Free Counseling Call</h3>
                <p style={{fontSize:14,color:"rgba(245,230,230,.35)",marginBottom:28,fontFamily:"'Sora',sans-serif"}}>No spam. No commitment. Just clarity.</p>
                
                <input required type="text" name="user_name" placeholder="Full Name" style={{background:"rgba(192,57,43,.08)",border:"1px solid rgba(192,57,43,.2)",borderRadius:11,padding:"13px 16px",color:"#fff",fontSize:14,outline:"none",fontFamily:"'Sora',sans-serif"}} />
                <input required type="email" name="user_email" placeholder="Email Address" style={{background:"rgba(192,57,43,.08)",border:"1px solid rgba(192,57,43,.2)",borderRadius:11,padding:"13px 16px",color:"#fff",fontSize:14,outline:"none",fontFamily:"'Sora',sans-serif"}} />
                <input required type="tel" name="user_phone" placeholder="Phone Number" style={{background:"rgba(192,57,43,.08)",border:"1px solid rgba(192,57,43,.2)",borderRadius:11,padding:"13px 16px",color:"#fff",fontSize:14,outline:"none",fontFamily:"'Sora',sans-serif"}} />
                <textarea required name="message" placeholder="Your Query" style={{background:"rgba(192,57,43,.08)",border:"1px solid rgba(192,57,43,.2)",borderRadius:11,padding:"13px 16px",color:"#fff",fontSize:14,outline:"none",fontFamily:"'Sora',sans-serif",minHeight:"80px"}} />
                
                <button type="submit" className="btn-royal" style={{padding:"15px",borderRadius:12,color:"#fff",fontSize:16,width:"100%",marginTop:4,fontFamily:"'Sora',sans-serif"}}>
                  Get Free Counseling →
                </button>
                <p style={{fontSize:11,color:"rgba(245,230,230,.2)",marginTop:16,textAlign:"center",fontFamily:"'Sora',sans-serif"}}>By submitting, you agree to our Terms & Privacy Policy.</p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}


// ── HOME PAGE ROOT ────────────────────────────────────────────────────────────
const Home = () => {
  let { isLogin } = useSelector((state) => state.AuthReducer);
  let dispatch = useDispatch();

  useEffect(() => {
    if (!isLogin) {
      dispatch(logoutAction());
    }
  }, [isLogin, dispatch]);

  return (
    <>
      <style>{CSS}</style>
      
      <Hero />
      <CompanyTicker />
      <StatsBar />
      <WhyUs />
      <UniversityTicker />
      
      <section className="top-courses-section">
        <TopCoursesAria />
      </section>

      <CoursesSection />
      <TechStack />
      <ProgramsSection />
      <ProcessSection />
      <MentorsSection />
      <AlumniSection />
      <AboutSection />
      <FAQ />
      <CTASection />
      
      {/* RENDER THE CHATBOT HERE */}
      <TechvantoChat />
    </>
  );
};

export default Home;